import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useContext, useEffect, useState, useCallback } from "react";

import { CareerChallengeSheetFormData } from "../../../state";
import {
  Context,
  fetchCareerLatestSheet,
  fetchCareerFeedbackSheets,
  fetchCareerFeedbackQuestions,
  fetchCareerChallengeSheet,
  createCareerSheets,
  createCareerChallengeSheets,
  saveCareerChallengeSheets,
  submitCareerChallengeSheets,
  APPLY_FOR_CAREER_MAP_GENERATION_SUCCESS_MESSAGE,
  SAVE_CAREER_CHALLENGE_SHEETS_SUCCESS_MESSAGE,
  SAVE_CAREER_CHALLENGE_SHEETS_FAILURE_MESSAGE,
  SUBMIT_CAREER_CHALLENGE_SHEETS_SUCCESS_MESSAGE,
  SUBMIT_CAREER_CHALLENGE_SHEETS_FAILURE_MESSAGE,
} from "../../../store/student";
import useCareerChallengeTopics from "../../../hooks/useCareerChallengeTopics";
import useToast from "../../../hooks/useToast";
import Toast from "../../../molecules/Toast";
import LoginHeader from "../../../organisms/LoginHeader";
import ChallengeSheetsModal from "../../../organisms/Career/ChallengeSheetsModal";
import Career from "../../../templates/Career";
import styles from "../common.module.scss";

const CareerPage = () => {
  const { contextState, dispatch } = useContext(Context);
  const { toast, setToast, handleToast } = useToast();
  const [isOpenChallengeSheet, setIsOpenChallengeSheet] = useState(false);
  const { calling, isCreateTopicsFailed, createTopics } =
    useCareerChallengeTopics(isOpenChallengeSheet);

  useIonViewWillEnter(() => {
    dispatch(fetchCareerLatestSheet());
    dispatch(fetchCareerFeedbackSheets());
    dispatch(fetchCareerFeedbackQuestions());
    dispatch(fetchCareerChallengeSheet());
  });

  // キャリア開拓シート画面からのリダイレクト直後では最新データを取得できないため、キャリア開拓MAP申請の成功後に再取得
  useEffect(() => {
    if (
      contextState.success_message ===
      APPLY_FOR_CAREER_MAP_GENERATION_SUCCESS_MESSAGE
    ) {
      dispatch(fetchCareerLatestSheet());
      dispatch(fetchCareerFeedbackSheets());
    }
  }, [dispatch, contextState.success_message]);

  useEffect(() => {
    const successMessages = [
      SAVE_CAREER_CHALLENGE_SHEETS_SUCCESS_MESSAGE,
      SUBMIT_CAREER_CHALLENGE_SHEETS_SUCCESS_MESSAGE,
    ];
    const errorMessages = [
      SAVE_CAREER_CHALLENGE_SHEETS_FAILURE_MESSAGE,
      SUBMIT_CAREER_CHALLENGE_SHEETS_FAILURE_MESSAGE,
    ];

    handleToast("success", contextState.success_message, successMessages);
    handleToast("danger", contextState.error, errorMessages);
  }, [contextState.success_message, contextState.error, handleToast]);

  const createCareerSheetsFunc = useCallback(() => {
    dispatch(createCareerSheets());
  }, [dispatch]);

  const createCareerChallengeSheetsFunc = useCallback(() => {
    dispatch(createCareerChallengeSheets());
  }, [dispatch]);

  const saveCareerChallengeSheetsFunc = useCallback(
    (id: number, formData: CareerChallengeSheetFormData) => {
      dispatch(saveCareerChallengeSheets(id, formData));
    },
    [dispatch],
  );

  const submitCareerChallengeSheetsFunc = useCallback(
    (id: number, formData: CareerChallengeSheetFormData) => {
      dispatch(submitCareerChallengeSheets(id, formData));
    },
    [dispatch],
  );

  return (
    <IonPage>
      <Toast
        type={toast.type}
        showToast={toast.isShow}
        onClose={() => setToast({ ...toast, isShow: false })}
        message={toast.message}
      />
      <ChallengeSheetsModal
        calling={calling}
        isCreateTopicsFailed={isCreateTopicsFailed}
        isOpen={isOpenChallengeSheet}
        createCareerChallengeSheets={createCareerChallengeSheetsFunc}
        createCareerChallengeTopics={createTopics}
        saveCareerChallengeSheets={saveCareerChallengeSheetsFunc}
        submitCareerChallengeSheets={submitCareerChallengeSheetsFunc}
        onClose={() => setIsOpenChallengeSheet(false)}
      />
      <LoginHeader title="キャリア開拓モード" unreadNotiCount={0} />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <Career
            createCareerSheets={createCareerSheetsFunc}
            onOpenChallengeSheet={() => setIsOpenChallengeSheet(true)}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CareerPage;
